export var AdEvents;
(function (AdEvents) {
    /**
     * When creative becomes visible (preload or creative)
     */
    AdEvents["Render"] = "render";
    /**
     * When preload is done
     */
    AdEvents["Preload"] = "preload";
    /**
     * When preload is done
     */
    AdEvents["CreativeLoad"] = "creativeload";
    /**
     * Initialization of Ad script is done and API is available
     */
    AdEvents["Init"] = "init";
    /**
     * Click on creative is triggered
     */
    AdEvents["Click"] = "click";
    /**
     * Creative is scrolled in view (at least one pixel is shown)
     */
    AdEvents["ViewEnter"] = "viewenter";
    /**
     * Creative is scrolled out of view (nothing of the creative is shown)
     */
    AdEvents["ViewLeave"] = "viewleave";
    /**
     * Creative is scrolled in view according (30% or 50% depending on ad size)
     */
    AdEvents["IABViewEnter"] = "iab_viewenter";
    /**
     * Creative is scrolled out of view (30% or 50% depending on ad size)
     */
    AdEvents["IABViewLeave"] = "iab_viewleave";
    /**
     * Page is ready for us to load animated creative
     */
    AdEvents["PageReady"] = "ready";
    /**
     * Something made the Ad crash
     */
    AdEvents["Error"] = "error";
    /**
     * When add is removed and memory should be freed.
     */
    AdEvents["Destroy"] = "destroy";
    AdEvents["Play"] = "play";
    AdEvents["Stop"] = "stop";
    AdEvents["Seek"] = "seek";
    AdEvents["Loop"] = "loop";
    AdEvents["Pause"] = "pause";
    AdEvents["Mute"] = "mute";
    /**
     * Transparency and Consensus data.
     *
     * @link
     * https://bannerflow.atlassian.net/secure/RapidBoard.jspa?rapidView=40&modal=detail&selectedIssue=STUDIO-5168
     */
    AdEvents["TCData"] = "tcdata";
})(AdEvents || (AdEvents = {}));
